<div class="d-flex justify-content-between align-items-center flex-wrap gap-3 mx-4">
    <span class="text-muted" style="font-weight: bold;">
      Showing 
      {{ (pageNumber - 1) * pageSize + 1 }} to 
      {{ (pageNumber - 1) * pageSize + itemsCount }} of 
      {{ recordsTotal ? (recordsTotal | number) : 0 }} 
      entries
    </span>

    <nav>
      <ul class="anq-pagination d-flex align-items-center justify-content-center gap-2 flex-wrap mb-0 p-0">
        <li 
          class="anq-pagination_item" 
          title="First Page"
          [class.disabled]="pageNumber === 1"
          (click)="firstPage()"
        >
          <i class="bi bi-chevron-double-left anq-pagination_item_icon"></i>
        </li>
        <li 
          class="anq-pagination_item" 
          title="Previous"
          [class.disabled]="pageNumber === 1"
          (click)="previousPage()"
        >
          <i class="bi bi-chevron-left anq-pagination_item_icon"></i>
        </li>
        <li>
          <div class="d-flex align-items-center gap-2">
            Page
            <input 
              type="number" 
              id="pageNumber"
              class="form-control"
              [(ngModel)]="tempPageNumber"
              (keyup.enter)="goToPage($event)" 
              [min]="1" 
              [max]="totalPages"
              [disabled]="!totalPages || totalPages <= 1" 
            >
            / {{ totalPages | number }}
          </div>
        </li>
        <li 
          class="anq-pagination_item" 
          title="Next"
          [class.disabled]="pageNumber === totalPages || totalPages <= 1 || !totalPages"
          (click)="nextPage()"
        >
          <i class="bi bi-chevron-right anq-pagination_item_icon"></i>
        </li>
        <li 
          class="anq-pagination_item" 
          title="Last Page"
          [class.disabled]="pageNumber === totalPages || totalPages <= 1 || !totalPages"
          (click)="lastPage()"
        >
          <i class="bi bi-chevron-double-right anq-pagination_item_icon"></i>
        </li>
      </ul>
    </nav>
</div>

